/* eslint-disable unused-imports/no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/**
 * Generated by orval v7.6.0 🍺
 * Do not edit manually.
 * Web Returns API
 * Documentation of the controllers and endpoints used in the web-returns-service.
 * OpenAPI spec version: deploy-only-BS-816-2484
 */
import type {
  AnnouncedReturnDTO,
  CreateAnnouncedReturn,
  GetReturnOptionsParams,
  GetReturnOptionsServerParams,
  GetReturnableSalesParams,
  GetReturnableSalesServerParams,
  GetReturnedSaleParams,
  GetReturnedSaleServerParams,
  GetReturnedSalesParams,
  GetReturnedSalesServerParams,
  GetSaleParams,
  GetSaleServerParams,
  GetSalesParams,
  GetSalesServerParams,
  RegisterReturnGuestParams,
  RegisterReturnGuestServerParams,
  RegisterReturnParams,
  RegisterReturnServerParams,
  ReturnOptionDTO,
  ReturnReasonDTO,
  ReturnedSaleDTO,
  SaleDTO,
  UpdateReturnLocationParams,
  UpdateReturnLocationServerParams,
} from '@as-react/common-types/web-returns-service';
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useCallback } from 'react';

import { queryFetch } from '../../utils/orval/queryFetch';
import { queryKeyMutator } from '../../utils/orval/queryKeyMutator';
import { useQueryFetch } from '../../utils/orval/useQueryFetch';
import type { ErrorType, BodyType } from '../../utils/orval/useQueryFetch';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Update the delivery method an announced return (authenticated)
 */
export const useUpdateReturnLocationHook = () => {
  const updateReturnLocation = useQueryFetch<string>();

  return useCallback(
    (
      returnAnnounceId: number,
      params: UpdateReturnLocationParams,
      operationName = 'updateReturnLocation',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>
    ) => {
      return updateReturnLocation(
        { url: `/api/webreturns/returns/announce/${returnAnnounceId}/location`, method: 'PUT', params },
        { operationName: 'updateReturnLocation', ...options }
      );
    },
    [updateReturnLocation]
  );
};

export const useUpdateReturnLocationMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateReturnLocationHook>>>,
    TError,
    { returnAnnounceId: number; params: UpdateReturnLocationParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useUpdateReturnLocationHook>>>,
  TError,
  { returnAnnounceId: number; params: UpdateReturnLocationParams; operationName?: string },
  TContext
> => {
  const mutationKey = ['updateReturnLocation'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const updateReturnLocation = useUpdateReturnLocationHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useUpdateReturnLocationHook>>>,
    { returnAnnounceId: number; params: UpdateReturnLocationParams; operationName?: string }
  > = props => {
    const { returnAnnounceId, params, operationName } = props ?? {};

    return updateReturnLocation(returnAnnounceId, params, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReturnLocationMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useUpdateReturnLocationHook>>>
>;

export type UpdateReturnLocationMutationError = ErrorType<unknown>;

export const useUpdateReturnLocation = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useUpdateReturnLocationHook>>>,
    TError,
    { returnAnnounceId: number; params: UpdateReturnLocationParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useUpdateReturnLocationHook>>>,
  TError,
  { returnAnnounceId: number; params: UpdateReturnLocationParams; operationName?: string },
  TContext
> => {
  const mutationOptions = useUpdateReturnLocationMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Update the delivery method an announced return (authenticated)
 */
export const updateReturnLocationServer = (
  returnAnnounceId: number,
  params: UpdateReturnLocationServerParams,
  operationName = 'updateReturnLocation',
  options?: SecondParameter<typeof queryFetch>
) => {
  return queryFetch<string>(
    { url: `/public/returns/announce/${returnAnnounceId}/location`, method: 'PUT', params },
    { operationName: 'updateReturnLocation', ...options }
  );
};

export const getUpdateReturnLocationServerMutationOptions = <
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReturnLocationServer>>,
    TError,
    { returnAnnounceId: number; params: UpdateReturnLocationServerParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReturnLocationServer>>,
  TError,
  { returnAnnounceId: number; params: UpdateReturnLocationServerParams; operationName?: string },
  TContext
> => {
  const mutationKey = ['updateReturnLocationServer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReturnLocationServer>>,
    { returnAnnounceId: number; params: UpdateReturnLocationServerParams; operationName?: string }
  > = props => {
    const { returnAnnounceId, params, operationName } = props ?? {};

    return updateReturnLocationServer(returnAnnounceId, params, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReturnLocationServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReturnLocationServer>>
>;

export type UpdateReturnLocationServerMutationError = ErrorType<unknown>;

export const useUpdateReturnLocationServer = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReturnLocationServer>>,
    TError,
    { returnAnnounceId: number; params: UpdateReturnLocationServerParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof updateReturnLocationServer>>,
  TError,
  { returnAnnounceId: number; params: UpdateReturnLocationServerParams; operationName?: string },
  TContext
> => {
  const mutationOptions = getUpdateReturnLocationServerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Register an announced return
 */
export const useRegisterReturnHook = () => {
  const registerReturn = useQueryFetch<AnnouncedReturnDTO>();

  return useCallback(
    (
      createAnnouncedReturn: BodyType<CreateAnnouncedReturn>,
      params: RegisterReturnParams,
      operationName = 'registerReturn',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return registerReturn(
        {
          url: `/api/webreturns/returns/announce/register`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: createAnnouncedReturn,
          params,
          signal,
        },
        { operationName: 'registerReturn', ...options }
      );
    },
    [registerReturn]
  );
};

export const useRegisterReturnMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRegisterReturnHook>>>,
    TError,
    { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRegisterReturnHook>>>,
  TError,
  { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnParams; operationName?: string },
  TContext
> => {
  const mutationKey = ['registerReturn'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const registerReturn = useRegisterReturnHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRegisterReturnHook>>>,
    { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnParams; operationName?: string }
  > = props => {
    const { data, params, operationName } = props ?? {};

    return registerReturn(data, params, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterReturnMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useRegisterReturnHook>>>>;
export type RegisterReturnMutationBody = BodyType<CreateAnnouncedReturn>;
export type RegisterReturnMutationError = ErrorType<unknown>;

export const useRegisterReturn = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRegisterReturnHook>>>,
    TError,
    { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRegisterReturnHook>>>,
  TError,
  { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnParams; operationName?: string },
  TContext
> => {
  const mutationOptions = useRegisterReturnMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Register an announced return
 */
export const registerReturnServer = (
  createAnnouncedReturn: CreateAnnouncedReturn,
  params: RegisterReturnServerParams,
  operationName = 'registerReturn',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<AnnouncedReturnDTO>(
    {
      url: `/public/returns/announce/register`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAnnouncedReturn,
      params,
      signal,
    },
    { operationName: 'registerReturn', ...options }
  );
};

export const getRegisterReturnServerMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerReturnServer>>,
    TError,
    { data: CreateAnnouncedReturn; params: RegisterReturnServerParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerReturnServer>>,
  TError,
  { data: CreateAnnouncedReturn; params: RegisterReturnServerParams; operationName?: string },
  TContext
> => {
  const mutationKey = ['registerReturnServer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerReturnServer>>,
    { data: CreateAnnouncedReturn; params: RegisterReturnServerParams; operationName?: string }
  > = props => {
    const { data, params, operationName } = props ?? {};

    return registerReturnServer(data, params, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterReturnServerMutationResult = NonNullable<Awaited<ReturnType<typeof registerReturnServer>>>;
export type RegisterReturnServerMutationBody = CreateAnnouncedReturn;
export type RegisterReturnServerMutationError = ErrorType<unknown>;

export const useRegisterReturnServer = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerReturnServer>>,
    TError,
    { data: CreateAnnouncedReturn; params: RegisterReturnServerParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerReturnServer>>,
  TError,
  { data: CreateAnnouncedReturn; params: RegisterReturnServerParams; operationName?: string },
  TContext
> => {
  const mutationOptions = getRegisterReturnServerMutationOptions(options);

  return useMutation(mutationOptions);
};

export const useRegisterReturnGuestHook = () => {
  const registerReturnGuest = useQueryFetch<AnnouncedReturnDTO>();

  return useCallback(
    (
      createAnnouncedReturn: BodyType<CreateAnnouncedReturn>,
      params: RegisterReturnGuestParams,
      operationName = 'registerReturnGuest',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return registerReturnGuest(
        {
          url: `/api/webreturns/returns/announce/register/guest`,
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          data: createAnnouncedReturn,
          params,
          signal,
        },
        { operationName: 'registerReturnGuest', ...options }
      );
    },
    [registerReturnGuest]
  );
};

export const useRegisterReturnGuestMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRegisterReturnGuestHook>>>,
    TError,
    { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnGuestParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
}): UseMutationOptions<
  Awaited<ReturnType<ReturnType<typeof useRegisterReturnGuestHook>>>,
  TError,
  { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnGuestParams; operationName?: string },
  TContext
> => {
  const mutationKey = ['registerReturnGuest'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const registerReturnGuest = useRegisterReturnGuestHook();

  const mutationFn: MutationFunction<
    Awaited<ReturnType<ReturnType<typeof useRegisterReturnGuestHook>>>,
    { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnGuestParams; operationName?: string }
  > = props => {
    const { data, params, operationName } = props ?? {};

    return registerReturnGuest(data, params, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterReturnGuestMutationResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useRegisterReturnGuestHook>>>
>;
export type RegisterReturnGuestMutationBody = BodyType<CreateAnnouncedReturn>;
export type RegisterReturnGuestMutationError = ErrorType<unknown>;

export const useRegisterReturnGuest = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useRegisterReturnGuestHook>>>,
    TError,
    { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnGuestParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
}): UseMutationResult<
  Awaited<ReturnType<ReturnType<typeof useRegisterReturnGuestHook>>>,
  TError,
  { data: BodyType<CreateAnnouncedReturn>; params: RegisterReturnGuestParams; operationName?: string },
  TContext
> => {
  const mutationOptions = useRegisterReturnGuestMutationOptions(options);

  return useMutation(mutationOptions);
};

export const registerReturnGuestServer = (
  createAnnouncedReturn: CreateAnnouncedReturn,
  params: RegisterReturnGuestServerParams,
  operationName = 'registerReturnGuest',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<AnnouncedReturnDTO>(
    {
      url: `/public/returns/announce/register/guest`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: createAnnouncedReturn,
      params,
      signal,
    },
    { operationName: 'registerReturnGuest', ...options }
  );
};

export const getRegisterReturnGuestServerMutationOptions = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerReturnGuestServer>>,
    TError,
    { data: CreateAnnouncedReturn; params: RegisterReturnGuestServerParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof registerReturnGuestServer>>,
  TError,
  { data: CreateAnnouncedReturn; params: RegisterReturnGuestServerParams; operationName?: string },
  TContext
> => {
  const mutationKey = ['registerReturnGuestServer'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof registerReturnGuestServer>>,
    { data: CreateAnnouncedReturn; params: RegisterReturnGuestServerParams; operationName?: string }
  > = props => {
    const { data, params, operationName } = props ?? {};

    return registerReturnGuestServer(data, params, operationName, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type RegisterReturnGuestServerMutationResult = NonNullable<
  Awaited<ReturnType<typeof registerReturnGuestServer>>
>;
export type RegisterReturnGuestServerMutationBody = CreateAnnouncedReturn;
export type RegisterReturnGuestServerMutationError = ErrorType<unknown>;

export const useRegisterReturnGuestServer = <TError = ErrorType<unknown>, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof registerReturnGuestServer>>,
    TError,
    { data: CreateAnnouncedReturn; params: RegisterReturnGuestServerParams; operationName?: string },
    TContext
  >;
  request?: SecondParameter<typeof queryFetch>;
}): UseMutationResult<
  Awaited<ReturnType<typeof registerReturnGuestServer>>,
  TError,
  { data: CreateAnnouncedReturn; params: RegisterReturnGuestServerParams; operationName?: string },
  TContext
> => {
  const mutationOptions = getRegisterReturnGuestServerMutationOptions(options);

  return useMutation(mutationOptions);
};

/**
 * Retrieve a list of sales and recent orders
 */
export const useGetSalesHook = () => {
  const getSales = useQueryFetch<Array<SaleDTO>>();

  return useCallback(
    (
      params: GetSalesParams,
      operationName = 'getSales',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getSales(
        { url: `/api/webreturns/returns/sales`, method: 'GET', params, signal },
        { operationName: 'getSales', ...options }
      );
    },
    [getSales]
  );
};

export const useGetSalesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSalesParams,
  operationName = 'getSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/webreturns/returns/sales`, queryOptions });

  const getSales = useGetSalesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>> = ({ signal }) =>
    getSales(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSalesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>>;
export type GetSalesQueryError = ErrorType<unknown>;

export function useGetSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSalesParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSalesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSalesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSalesParams,
  operationName = 'getSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSalesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetSalesQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a list of sales and recent orders
 */
export const getSalesServer = (
  params: GetSalesServerParams,
  operationName = 'getSales',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<SaleDTO>>(
    { url: `/public/returns/sales`, method: 'GET', params, signal },
    { operationName: 'getSales', ...options }
  );
};

export const useGetSalesServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetSalesServerParams,
  operationName = 'getSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/public/returns/sales`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSalesServer>>> = ({ signal }) =>
    getSalesServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSalesServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSalesServerQueryResult = NonNullable<Awaited<ReturnType<typeof getSalesServer>>>;
export type GetSalesServerQueryError = ErrorType<unknown>;

export function useGetSalesServer<TData = Awaited<ReturnType<typeof getSalesServer>>, TError = ErrorType<unknown>>(
  params: GetSalesServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesServer>>,
          TError,
          Awaited<ReturnType<typeof getSalesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSalesServer<TData = Awaited<ReturnType<typeof getSalesServer>>, TError = ErrorType<unknown>>(
  params: GetSalesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSalesServer>>,
          TError,
          Awaited<ReturnType<typeof getSalesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSalesServer<TData = Awaited<ReturnType<typeof getSalesServer>>, TError = ErrorType<unknown>>(
  params: GetSalesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSalesServer<TData = Awaited<ReturnType<typeof getSalesServer>>, TError = ErrorType<unknown>>(
  params: GetSalesServerParams,
  operationName = 'getSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSalesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetSalesServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a list of returned or marked as returned sales
 */
export const useGetReturnedSalesHook = () => {
  const getReturnedSales = useQueryFetch<Array<ReturnedSaleDTO>>();

  return useCallback(
    (
      params: GetReturnedSalesParams,
      operationName = 'getReturnedSales',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getReturnedSales(
        { url: `/api/webreturns/returns/sales/returned`, method: 'GET', params, signal },
        { operationName: 'getReturnedSales', ...options }
      );
    },
    [getReturnedSales]
  );
};

export const useGetReturnedSalesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesParams,
  operationName = 'getReturnedSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { params, operationName },
    { url: `/api/webreturns/returns/sales/returned`, queryOptions }
  );

  const getReturnedSales = useGetReturnedSalesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>> = ({ signal }) =>
    getReturnedSales(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnedSalesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>>;
export type GetReturnedSalesQueryError = ErrorType<unknown>;

export function useGetReturnedSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnedSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnedSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnedSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesParams,
  operationName = 'getReturnedSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSalesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnedSalesQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a list of returned or marked as returned sales
 */
export const getReturnedSalesServer = (
  params: GetReturnedSalesServerParams,
  operationName = 'getReturnedSales',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<ReturnedSaleDTO>>(
    { url: `/public/returns/sales/returned`, method: 'GET', params, signal },
    { operationName: 'getReturnedSales', ...options }
  );
};

export const useGetReturnedSalesServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getReturnedSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesServerParams,
  operationName = 'getReturnedSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSalesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/public/returns/sales/returned`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnedSalesServer>>> = ({ signal }) =>
    getReturnedSalesServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReturnedSalesServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnedSalesServerQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnedSalesServer>>>;
export type GetReturnedSalesServerQueryError = ErrorType<unknown>;

export function useGetReturnedSalesServer<
  TData = Awaited<ReturnType<typeof getReturnedSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSalesServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnedSalesServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnedSalesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnedSalesServer<
  TData = Awaited<ReturnType<typeof getReturnedSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSalesServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnedSalesServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnedSalesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnedSalesServer<
  TData = Awaited<ReturnType<typeof getReturnedSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSalesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnedSalesServer<
  TData = Awaited<ReturnType<typeof getReturnedSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSalesServerParams,
  operationName = 'getReturnedSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSalesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnedSalesServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a list of sales that can be returned
 */
export const useGetReturnableSalesHook = () => {
  const getReturnableSales = useQueryFetch<Array<SaleDTO>>();

  return useCallback(
    (
      params: GetReturnableSalesParams,
      operationName = 'getReturnableSales',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getReturnableSales(
        { url: `/api/webreturns/returns/sales/returnable`, method: 'GET', params, signal },
        { operationName: 'getReturnableSales', ...options }
      );
    },
    [getReturnableSales]
  );
};

export const useGetReturnableSalesQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesParams,
  operationName = 'getReturnableSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { params, operationName },
    { url: `/api/webreturns/returns/sales/returnable`, queryOptions }
  );

  const getReturnableSales = useGetReturnableSalesHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>> = ({ signal }) =>
    getReturnableSales(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnableSalesQueryResult = NonNullable<
  Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>
>;
export type GetReturnableSalesQueryError = ErrorType<unknown>;

export function useGetReturnableSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnableSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnableSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnableSales<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesParams,
  operationName = 'getReturnableSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnableSalesHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnableSalesQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a list of sales that can be returned
 */
export const getReturnableSalesServer = (
  params: GetReturnableSalesServerParams,
  operationName = 'getReturnableSales',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<SaleDTO>>(
    { url: `/public/returns/sales/returnable`, method: 'GET', params, signal },
    { operationName: 'getReturnableSales', ...options }
  );
};

export const useGetReturnableSalesServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getReturnableSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesServerParams,
  operationName = 'getReturnableSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnableSalesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { params, operationName },
    { url: `/public/returns/sales/returnable`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnableSalesServer>>> = ({ signal }) =>
    getReturnableSalesServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReturnableSalesServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnableSalesServerQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnableSalesServer>>>;
export type GetReturnableSalesServerQueryError = ErrorType<unknown>;

export function useGetReturnableSalesServer<
  TData = Awaited<ReturnType<typeof getReturnableSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnableSalesServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnableSalesServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnableSalesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnableSalesServer<
  TData = Awaited<ReturnType<typeof getReturnableSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnableSalesServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnableSalesServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnableSalesServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnableSalesServer<
  TData = Awaited<ReturnType<typeof getReturnableSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnableSalesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnableSalesServer<
  TData = Awaited<ReturnType<typeof getReturnableSalesServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnableSalesServerParams,
  operationName = 'getReturnableSales',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnableSalesServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnableSalesServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a single sale
 */
export const useGetSaleHook = () => {
  const getSale = useQueryFetch<SaleDTO>();

  return useCallback(
    (
      params: GetSaleParams,
      operationName = 'getSale',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getSale(
        { url: `/api/webreturns/returns/sale`, method: 'GET', params, signal },
        { operationName: 'getSale', ...options }
      );
    },
    [getSale]
  );
};

export const useGetSaleQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetSaleParams,
  operationName = 'getSale',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/webreturns/returns/sale`, queryOptions });

  const getSale = useGetSaleHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>> = ({ signal }) =>
    getSale(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSaleQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>>;
export type GetSaleQueryError = ErrorType<unknown>;

export function useGetSale<TData = Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>, TError = ErrorType<unknown>>(
  params: GetSaleParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSale<TData = Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>, TError = ErrorType<unknown>>(
  params: GetSaleParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSale<TData = Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>, TError = ErrorType<unknown>>(
  params: GetSaleParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSale<TData = Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>, TError = ErrorType<unknown>>(
  params: GetSaleParams,
  operationName = 'getSale',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetSaleHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetSaleQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a single sale
 */
export const getSaleServer = (
  params: GetSaleServerParams,
  operationName = 'getSale',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<SaleDTO>(
    { url: `/public/returns/sale`, method: 'GET', params, signal },
    { operationName: 'getSale', ...options }
  );
};

export const useGetSaleServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getSaleServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetSaleServerParams,
  operationName = 'getSale',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSaleServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/public/returns/sale`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getSaleServer>>> = ({ signal }) =>
    getSaleServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getSaleServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetSaleServerQueryResult = NonNullable<Awaited<ReturnType<typeof getSaleServer>>>;
export type GetSaleServerQueryError = ErrorType<unknown>;

export function useGetSaleServer<TData = Awaited<ReturnType<typeof getSaleServer>>, TError = ErrorType<unknown>>(
  params: GetSaleServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSaleServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSaleServer>>,
          TError,
          Awaited<ReturnType<typeof getSaleServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSaleServer<TData = Awaited<ReturnType<typeof getSaleServer>>, TError = ErrorType<unknown>>(
  params: GetSaleServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSaleServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSaleServer>>,
          TError,
          Awaited<ReturnType<typeof getSaleServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetSaleServer<TData = Awaited<ReturnType<typeof getSaleServer>>, TError = ErrorType<unknown>>(
  params: GetSaleServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSaleServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetSaleServer<TData = Awaited<ReturnType<typeof getSaleServer>>, TError = ErrorType<unknown>>(
  params: GetSaleServerParams,
  operationName = 'getSale',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getSaleServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetSaleServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a list of returned or marked as returned sales based on the original saleId
 */
export const useGetReturnedSaleHook = () => {
  const getReturnedSale = useQueryFetch<Array<ReturnedSaleDTO>>();

  return useCallback(
    (
      params: GetReturnedSaleParams,
      operationName = 'getReturnedSale',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getReturnedSale(
        { url: `/api/webreturns/returns/sale/returned`, method: 'GET', params, signal },
        { operationName: 'getReturnedSale', ...options }
      );
    },
    [getReturnedSale]
  );
};

export const useGetReturnedSaleQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleParams,
  operationName = 'getReturnedSale',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { params, operationName },
    { url: `/api/webreturns/returns/sale/returned`, queryOptions }
  );

  const getReturnedSale = useGetReturnedSaleHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>> = ({ signal }) =>
    getReturnedSale(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnedSaleQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>>;
export type GetReturnedSaleQueryError = ErrorType<unknown>;

export function useGetReturnedSale<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnedSale<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnedSale<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnedSale<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleParams,
  operationName = 'getReturnedSale',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnedSaleHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnedSaleQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a list of returned or marked as returned sales based on the original saleId
 */
export const getReturnedSaleServer = (
  params: GetReturnedSaleServerParams,
  operationName = 'getReturnedSale',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<ReturnedSaleDTO>>(
    { url: `/public/returns/sale/returned`, method: 'GET', params, signal },
    { operationName: 'getReturnedSale', ...options }
  );
};

export const useGetReturnedSaleServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getReturnedSaleServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleServerParams,
  operationName = 'getReturnedSale',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSaleServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/public/returns/sale/returned`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnedSaleServer>>> = ({ signal }) =>
    getReturnedSaleServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReturnedSaleServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnedSaleServerQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnedSaleServer>>>;
export type GetReturnedSaleServerQueryError = ErrorType<unknown>;

export function useGetReturnedSaleServer<
  TData = Awaited<ReturnType<typeof getReturnedSaleServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSaleServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnedSaleServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnedSaleServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnedSaleServer<
  TData = Awaited<ReturnType<typeof getReturnedSaleServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSaleServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnedSaleServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnedSaleServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnedSaleServer<
  TData = Awaited<ReturnType<typeof getReturnedSaleServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSaleServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnedSaleServer<
  TData = Awaited<ReturnType<typeof getReturnedSaleServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnedSaleServerParams,
  operationName = 'getReturnedSale',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnedSaleServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnedSaleServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const useGetReturnReasonsHook = () => {
  const getReturnReasons = useQueryFetch<Array<ReturnReasonDTO>>();

  return useCallback(
    (
      market: string,
      language: string,
      operationName = 'getReturnReasons',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getReturnReasons(
        { url: `/api/webreturns/returnreason/${market}/${language}`, method: 'GET', signal },
        { operationName: 'getReturnReasons', ...options }
      );
    },
    [getReturnReasons]
  );
};

export const useGetReturnReasonsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName = 'getReturnReasons',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, language, operationName },
    { url: `/api/webreturns/returnreason/${market}/${language}`, queryOptions }
  );

  const getReturnReasons = useGetReturnReasonsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>> = ({ signal }) =>
    getReturnReasons(market, language, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(market && language), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnReasonsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>>;
export type GetReturnReasonsQueryError = ErrorType<unknown>;

export function useGetReturnReasons<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnReasons<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnReasons<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnReasons<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName = 'getReturnReasons',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnReasonsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnReasonsQueryOptions(market, language, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getReturnReasonsServer = (
  market: string,
  language: string,
  operationName = 'getReturnReasons',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<ReturnReasonDTO>>(
    { url: `/public/returnreason/${market}/${language}`, method: 'GET', signal },
    { operationName: 'getReturnReasons', ...options }
  );
};

export const useGetReturnReasonsServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getReturnReasonsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName = 'getReturnReasons',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnReasonsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator(
    { market, language, operationName },
    { url: `/public/returnreason/${market}/${language}`, queryOptions }
  );

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnReasonsServer>>> = ({ signal }) =>
    getReturnReasonsServer(market, language, operationName, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!(market && language), ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReturnReasonsServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnReasonsServerQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnReasonsServer>>>;
export type GetReturnReasonsServerQueryError = ErrorType<unknown>;

export function useGetReturnReasonsServer<
  TData = Awaited<ReturnType<typeof getReturnReasonsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnReasonsServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnReasonsServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnReasonsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnReasonsServer<
  TData = Awaited<ReturnType<typeof getReturnReasonsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnReasonsServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnReasonsServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnReasonsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnReasonsServer<
  TData = Awaited<ReturnType<typeof getReturnReasonsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnReasonsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnReasonsServer<
  TData = Awaited<ReturnType<typeof getReturnReasonsServer>>,
  TError = ErrorType<unknown>,
>(
  market: string,
  language: string,
  operationName = 'getReturnReasons',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnReasonsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnReasonsServerQueryOptions(market, language, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a list of return options
 */
export const useGetReturnOptionsHook = () => {
  const getReturnOptions = useQueryFetch<Array<ReturnOptionDTO>>();

  return useCallback(
    (
      params: GetReturnOptionsParams,
      operationName = 'getReturnOptions',
      options?: SecondParameter<ReturnType<typeof useQueryFetch>>,
      signal?: AbortSignal
    ) => {
      return getReturnOptions(
        { url: `/api/webreturns/returnoptions`, method: 'GET', params, signal },
        { operationName: 'getReturnOptions', ...options }
      );
    },
    [getReturnOptions]
  );
};

export const useGetReturnOptionsQueryOptions = <
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsParams,
  operationName = 'getReturnOptions',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/api/webreturns/returnoptions`, queryOptions });

  const getReturnOptions = useGetReturnOptionsHook();

  const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>> = ({ signal }) =>
    getReturnOptions(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnOptionsQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>>;
export type GetReturnOptionsQueryError = ErrorType<unknown>;

export function useGetReturnOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>
        >,
        'initialData'
      >;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnOptions<
  TData = Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsParams,
  operationName = 'getReturnOptions',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useGetReturnOptionsHook>>>, TError, TData>>;
    request?: SecondParameter<ReturnType<typeof useQueryFetch>>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnOptionsQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Retrieve a list of return options
 */
export const getReturnOptionsServer = (
  params: GetReturnOptionsServerParams,
  operationName = 'getReturnOptions',
  options?: SecondParameter<typeof queryFetch>,
  signal?: AbortSignal
) => {
  return queryFetch<Array<ReturnOptionDTO>>(
    { url: `/public/returnoptions`, method: 'GET', params, signal },
    { operationName: 'getReturnOptions', ...options }
  );
};

export const useGetReturnOptionsServerQueryOptions = <
  TData = Awaited<ReturnType<typeof getReturnOptionsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsServerParams,
  operationName = 'getReturnOptions',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnOptionsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryKeyMutator({ params, operationName }, { url: `/public/returnoptions`, queryOptions });

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getReturnOptionsServer>>> = ({ signal }) =>
    getReturnOptionsServer(params, operationName, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getReturnOptionsServer>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReturnOptionsServerQueryResult = NonNullable<Awaited<ReturnType<typeof getReturnOptionsServer>>>;
export type GetReturnOptionsServerQueryError = ErrorType<unknown>;

export function useGetReturnOptionsServer<
  TData = Awaited<ReturnType<typeof getReturnOptionsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsServerParams,
  operationName: undefined | string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnOptionsServer>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnOptionsServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnOptionsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnOptionsServer<
  TData = Awaited<ReturnType<typeof getReturnOptionsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnOptionsServer>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReturnOptionsServer>>,
          TError,
          Awaited<ReturnType<typeof getReturnOptionsServer>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetReturnOptionsServer<
  TData = Awaited<ReturnType<typeof getReturnOptionsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsServerParams,
  operationName?: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnOptionsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetReturnOptionsServer<
  TData = Awaited<ReturnType<typeof getReturnOptionsServer>>,
  TError = ErrorType<unknown>,
>(
  params: GetReturnOptionsServerParams,
  operationName = 'getReturnOptions',
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getReturnOptionsServer>>, TError, TData>>;
    request?: SecondParameter<typeof queryFetch>;
  }
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = useGetReturnOptionsServerQueryOptions(params, operationName, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
